import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import axios from "axios";
import moment from "moment";
import styles from "../MonitoringComponents/MonitoringComponents.module.scss";

function ErrorsTimeline({ building }) {
  const [timelineData, setTimelineData] = useState([]);

  const currentPage = 1;
  // const [totalNumberOfRows, setTotalNumberOfRows] = useState(1);
  const rowsPerPage = 5;

  useEffect(() => {
    // Get 200 rows, 10 at a time
    const getActions = async (currentPage) => {
      const response = await axios.get("/actions/getActionsErrorClient", {
        params: {
          page: currentPage,
          buildingId: building.id,
        },
      });
      if (response.status === 200) {
        // setTotalNumberOfRows(response.data.count);
        setTimelineData(response.data.rows);
      }
    }

    getActions(currentPage);
  }, [currentPage, building]);

  return (
    <div className={styles.TimelineContainerClient}>
      {timelineData.length > 0 ? (
        <>
          <Table striped>
            <thead>
              <tr>
                <th>Action</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {timelineData
                .slice(
                  (currentPage - 1) * rowsPerPage,
                  currentPage * rowsPerPage
                )
                .map((item, index) => (
                  <tr key={index}>
                    <td className={styles.TextWrap}>{item.event}</td>
                    <td>
                      {moment(item.created_at).format("Do MMMM YYYY, h:mm a")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </>
      ) : (
        <div className={styles.NoDataMessageClient}>Battery is Healthy!</div>
      )}
    </div>
  );
};

export default ErrorsTimeline;
